import { render } from "./expertsListing.vue?vue&type=template&id=6ef68f72&scoped=true"
import script from "./expertsListing.vue?vue&type=script&lang=js"
export * from "./expertsListing.vue?vue&type=script&lang=js"

import "./expertsListing.vue?vue&type=style&index=0&id=6ef68f72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef68f72"]])

export default __exports__